export default __webpack_public_path__ + "static/dynamic-ai-dark-9189a870c4ee392f14dff60e52c71f166c76b66ed89936a01f904850331346c6.png";